import { useSettingsStore } from '../stores/useSettingsStore'

export const MASK = '•••••'

const KEY = 'public-trading-privacy'

interface PersistedShape {
  state?: { hidden?: boolean }
  hidden?: boolean
}

function readHidden(): boolean {
  const raw = useSettingsStore.getState().values[KEY]
  if (raw == null) return false
  try {
    const parsed = JSON.parse(raw) as PersistedShape
    // The legacy zustand-persist value was wrapped in `{ state: { hidden } }`;
    // post-migration we just store the bare boolean.
    if (typeof parsed === 'boolean') return parsed
    if (typeof parsed?.hidden === 'boolean') return parsed.hidden
    if (typeof parsed?.state?.hidden === 'boolean') return parsed.state.hidden
  } catch {
    // ignore
  }
  return false
}

function writeHidden(next: boolean) {
  useSettingsStore.getState().set(KEY, JSON.stringify(next))
}

export function usePrivacyHidden(): boolean {
  return useSettingsStore((s) => {
    const raw = s.values[KEY]
    if (raw == null) return false
    try {
      const parsed = JSON.parse(raw) as PersistedShape
      if (typeof parsed === 'boolean') return parsed
      if (typeof parsed?.hidden === 'boolean') return parsed.hidden
      if (typeof parsed?.state?.hidden === 'boolean') return parsed.state.hidden
    } catch {
      // ignore
    }
    return false
  })
}

// Mirrors the previous zustand store API so call sites that imported
// `usePrivacyStore` directly keep working. `getState`/`setState` are not
// supported — use the named helpers below instead.
export const usePrivacyStore = {
  getState: () => ({
    hidden: readHidden(),
    toggle: () => writeHidden(!readHidden()),
    setHidden: (v: boolean) => writeHidden(v),
  }),
  togglePrivacy: () => writeHidden(!readHidden()),
  setPrivacyHidden: (v: boolean) => writeHidden(v),
}

export function useMaskMoney(): (formatted: string) => string {
  const hidden = usePrivacyHidden()
  return (formatted: string) => (hidden ? MASK : formatted)
}
